/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react'
import { Eyebrow } from '@alto-avios/alto-ui'
import {
  ContentfulComponentHero,
  ContentfulHeroSection as ContentfulHeroSectionLegacy,
} from '@reward-platform/contentful'
import { Hero } from '~/components/shared/Hero'
import { getContentfulImageProps } from '~/utils/assets'
import { RichText } from './ContentfulRichText'
import ContentfulCta from './ContentfulCta'

type ContentfulHeroImageProps = Omit<ContentfulComponentHero, 'contentType'> & {
  overlayContent?: React.ReactNode
}

export const normaliseHeroProps = (
  props?: ContentfulHeroSectionLegacy | ContentfulComponentHero
): ContentfulComponentHero | undefined => {
  if (!props || props.contentType === 'component-hero') {
    return props
  }
  return {
    ...props,
    identifier: props.entryId,
    heading: props.heading,
    bodyCopy: props.body,
    contentType: 'component-hero',
    variant: normaliseHeroProps(props.variant),
  }
}

export const ContentfulHeroImage = ({
  identifier,
  image,
  heading,
  bodyCopy,
  subheading,
  cta,
  badge,
  entryId,
  revisionId,
  overlayContent,
  children,
  bynderImage,
}: React.PropsWithChildren<ContentfulHeroImageProps>) => {
  const { imgSrc, imgAlt } = getContentfulImageProps({ bynderImage, image })

  return (
    <Hero imgSrc={imgSrc} imgAlt={imgAlt} overlayContent={overlayContent}>
      {badge?.label ? <Eyebrow styleVariant="spend">{badge.label}</Eyebrow> : null}
      {heading ? <Hero.Heading>{heading}</Hero.Heading> : null}
      {subheading ? <Hero.SubHeading>{subheading}</Hero.SubHeading> : null}
      {bodyCopy ? (
        <Hero.Tagline>
          <RichText document={bodyCopy} />
        </Hero.Tagline>
      ) : null}
      {cta ? (
        <ContentfulCta
          {...cta}
          eventData={{
            sectionHeading: heading ?? 'page hero',
            sectionId: identifier ?? 'page-hero',
            contentfulEntryId: entryId,
            contentfulRevisionId: revisionId,
          }}
        />
      ) : null}
      {children}
    </Hero>
  )
}
